export default __webpack_public_path__ + "static/media/sun.8b64ed4c.png";